import React, { createContext, useContext } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import router from './router';
import Layout from './global/Layout';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';

const root = ReactDOM.createRoot(document.getElementById('root'));
const MainContext = createContext(null);
  
  export const useMainControllerState = () => {
    return useContext(MainContext);
  };

  const routes = router.map(el => {
    const Component = require(`./controller/${el.name}`).default
    return {
        path: "/",
        element: <Layout />,
        children: [
            {
                path: el.name,
                element: <Component />,
            },
        ],
    }
  })

root.render(
    <MainContext.Provider value={{}}>
     <RouterProvider router={
            createBrowserRouter(routes)
        } />
    </MainContext.Provider>
);
